import { LoggerService } from './logger.interface';

export class NullLoggerService implements LoggerService {
  debug = () => {};
  error = () => {};
  info = () => {};
  log = () => {};
  warn = () => {};
}
